module.exports = __webpack_public_path__ + "img/2.fae6e59e.jpg";